import type { MouseEvent } from 'react';

import styles from './QtyStepper.module.css';

interface QtyStepperProps {
  value: number;
  onChange: (next: number) => void;
  min?: number;
  max?: number;
  className?: string;
}

export default function QtyStepper({
  value,
  onChange,
  min = 0,
  max,
  className = '',
}: QtyStepperProps) {
  const stop = (e: MouseEvent) => e.stopPropagation();
  const canDec = value > min;
  const canInc = max == null || value < max;

  const clamp = (n: number): number => {
    if (n < min) return min;
    if (max != null && n > max) return max;
    return n;
  };

  return (
    <div className={`${styles.root} ${className}`.trim()} onClick={stop}>
      <button
        type="button"
        className={styles.btn}
        onClick={() => onChange(clamp(value - 1))}
        disabled={!canDec}
        aria-label="decrease"
      >
        −
      </button>
      <span className={styles.value}>{value}</span>
      <button
        type="button"
        className={styles.btn}
        onClick={() => onChange(clamp(value + 1))}
        disabled={!canInc}
        aria-label="increase"
      >
        +
      </button>
    </div>
  );
}
